import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { PlatformClientService } from '@pure/pure1-ui-platform-angular';

@Component({
    selector: 'tou-modal',
    templateUrl: './tou-modal.component.html',
})
export class TouModalComponent {
    constructor(
        private readonly ngbActiveModal: NgbActiveModal,
        private readonly platformClientService: PlatformClientService,
    ) {}

    logout(): void {
        this.platformClientService.logout();
    }

    acceptTermsOfUse(): void {
        this.ngbActiveModal.close();
    }
}
